import gql from 'graphql-tag';

export const GoodClaimCreateMutation = gql`
	mutation GoodClaimCreateMutation($values: GoodClaimCreateInput!) {
		results: goodClaimCreate(values: $values) {
			id
			localId
			name
		}
	}
`;
